import React, { useState } from "react";

const SimInputBar = ({ name, type, placeholder, label, value, onChange, errorMessage = null, className, ...rest }) => {
  const inputClassNames = `form-control ${errorMessage ? "border-danger" : ""} ${className || ""}`;

  return (
    <>
      <div className="sim-input">
        {label && <label>{label}</label>}
        <input
          className={inputClassNames}
          type={type}
          name={name}
          placeholder={placeholder}
          value={value}
          onChange={onChange}
          {...rest}
        />
        {errorMessage && <p className="error-here"> {errorMessage} </p>}
      </div>
    </>
  );
};

export default SimInputBar;
